var exports = {
  "kL": "x234b8571--a9df0d--container",
  "AS": "x234b8571--a9df0d--item",
  "Pf": "x234b8571--a9df0d--label",
};

module.exports = exports;
